import api from "./api"

// 그룹 목록 조회
export const getAptGroupsAPI = async () => {
  const { data } = await api.get("/api/apt_groups")
  return data
}

// 그룹 생성
export const createAptGroupAPI = async ({ group_name, color_key }) => {
  const { data } = await api.post("/api/apt_groups", {
    group_name,
    color_key
  })
  return data
}

// 그룹 정보 수정
export const updateAptGroupAPI = async ({ group_id, group_name, color_key }) => {
  const { data } = await api.patch(`/api/apt_groups/${group_id}`, {
    group_name,
    color_key
  })
  return data
}

// 그룹 삭제
export const deleteAptGroupAPI = async ({ group_id }) => {
  await api.delete(`/api/apt_groups/${group_id}`)
  return true
}

// 그룹에 아파트 추가
export const addAptToGroupAPI = async ({ group_id, kapt_code }) => {
  await api.put(`/api/apt_groups/${group_id}/apts/${kapt_code}`)
  return true
}

// 그룹에서 아파트 제거
export const removeAptFromGroupAPI = async ({ group_id, kapt_code }) => {
  await api.delete(`/api/apt_groups/${group_id}/apts/${kapt_code}`)
  return true
}

// 그룹의 아파트 목록 일괄 변경
export const replaceAptsInGroupAPI = async ({ group_id, codes }) => {
  const { data } = await api.put(`/api/apt_groups/${group_id}/apts`, {
    codes
  })

  return data
}
